import React, { createContext, useContext, useState, useEffect } from 'react';
import { useMount } from '../helpers';
import * as DAL from './DAL';

// ====================

const context = createContext();

export const useLiveContentDayReportContext = () => useContext(context);

// ====================

const provider = ({ children }) => {
    const [logsList, setLogsList] = useState([]);
    const [selectedLog, setSelectedLog] = useState();
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [pdfFilename, setPdfFilename] = useState();
    const [reportData, setReportData] = useState([]);
    const [startHour, setStartHour] = useState('0');
    const [endHour, setEndHour] = useState(24);
    const [startHourList, setStartHourList] = useState([]);
    const [endHourList, setEndHourList] = useState([]);

    useMount(() => {
        DAL.getTransmittersList(setLogsList);
        for (let i = 0; i <= 23; i++) {
            startHourList.push({ id: i.toString(), name: i.toString().length === 1 ? '0' + i : i });
        }

        setStartHourList(startHourList);
        for (let i = 24; i >= 0; i--) {
            endHourList.push({ id: i, name: i.toString().length === 1 ? '0' + i.toString() : i });
        }
        setEndHourList(endHourList);
    });

    const requestReportData = (logId, date) => {
        if (logId && date) {
            setReportData(undefined);
            DAL.getLiveContentDayReport(logId, date, setReportData);
        }
    };

    const handleSelectLog = (logId) => {
        const log = logsList.find(l => l.id === logId);
        setSelectedLog(log);
        requestReportData(log.id, selectedDate);

    };
    const handleSelectDate = (date) => {
        setSelectedDate(date);
        requestReportData(selectedLog?.id, date);
    };

    useEffect(() => {
        if (selectedLog) {
            const mthNum = new Date().getMonth().toString().padStart(2, 0);
            const dayNum = new Date().getDate().toString().padStart(2, 0);
            setPdfFilename(`${selectedLog.name}_${mthNum}.${dayNum}_log_report.PDF`);
        }
    }, [selectedLog]);
    const clearDownload = () => { };

    return (
        <context.Provider
            value={{
                startHour,
                setStartHour,
                endHour,
                setEndHour,
                logsList,
                selectedLog,
                startHourList,
                endHourList,

                handleSelectLog,

                selectedDate,
                handleSelectDate,

                clearDownload,
                pdfFilename,

                reportData
            }}
        >
            {children}
        </context.Provider>
    );
};

export const LiveContentDayReportContextProvider = React.memo(provider);
